import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import AvailabilityEditor from "@/components/portal/AvailabilityEditor";
import SlotsPreview from "@/components/portal/SlotsPreview";
import { PageHeader, Panel, EmptyState, StatusBadge, Spinner, inputCls } from "@/components/portal/ui";

export default function AdminCalendar() {
  const [params, setParams] = useSearchParams();
  const [doctors, setDoctors] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const doctorId = params.get("doctor") || "";

  useEffect(() => {
    api.get("/doctors").then((r) => {
      setDoctors(r.data);
      if (!params.get("doctor") && r.data.length) setParams({ doctor: (r.data.find((d) => d.status === "approved") || r.data[0]).id }, { replace: true });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doctor = doctors?.find((d) => d.id === doctorId);

  return (
    <div data-testid="admin-calendar">
      <PageHeader
        eyebrow="Calendario"
        title="Disponibilità dei medici"
        desc="Visualizza e modifica gli orari di ogni medico. Gli slot liberi alimentano le risposte automatiche su WhatsApp e la creazione delle visite."
        actions={
          doctors && (
            <select value={doctorId} onChange={(e) => setParams({ doctor: e.target.value })} className={`${inputCls} !w-auto min-w-[240px]`} data-testid="calendar-doctor-select">
              {doctors.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.first_name} {d.last_name}{d.status !== "approved" ? ` (${d.status === "pending" ? "in attesa" : d.status})` : ""}
                </option>
              ))}
            </select>
          )
        }
      />

      {doctors === null ? (
        <div className="flex justify-center py-16"><Spinner /></div>
      ) : doctors.length === 0 ? (
        <EmptyState title="Nessun medico registrato" desc="Quando un medico si registra potrai gestire qui il suo calendario." />
      ) : doctor ? (
        <div className="flex flex-col gap-6">
          <Panel className="flex flex-wrap items-center justify-between gap-3" data-testid="calendar-doctor-card">
            <div>
              <p className="font-heading text-xl font-semibold">{doctor.first_name} {doctor.last_name}</p>
              <p className="text-sm text-[#6B6280]">{(doctor.specialties || []).map((s) => s.name).join(" · ") || "Nessuna specialità"} {doctor.city ? `· ${doctor.city}` : ""}</p>
            </div>
            <StatusBadge status={doctor.status} testid="calendar-doctor-status" />
          </Panel>
          {doctor.status !== "approved" && (
            <p className="rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="calendar-not-approved-note">Il medico non è ancora approvato: i suoi orari non vengono comunicati ai pazienti finché non lo approvi.</p>
          )}
          <AvailabilityEditor endpoint={`/availability/doctor/${doctor.id}`} onSaved={() => setRefreshKey((k) => k + 1)} />
          <SlotsPreview doctorId={doctor.id} refreshKey={refreshKey} title="Slot liberi del medico" />
        </div>
      ) : (
        <EmptyState title="Medico non trovato" />
      )}
    </div>
  );
}
